document.addEventListener('DOMContentLoaded', () => {
    let estimation_fields = document.querySelector('#repair_quotation_values_form_fields');

    if (estimation_fields !== null) {
        function recalculate_estimation(e) {
            let field_container, subtotal_input, vat_input, total_input, subtotal_amount, vat_amount,
                total_amount;

            field_container = e.closest('.columns');
            subtotal_input = field_container.querySelector('.subtotal');
            vat_input = field_container.querySelector('.vat');
            total_input = field_container.querySelector('.total');

            subtotal_amount = parseFloat(subtotal_input.value.replace(' ', ''));

            if (isNaN(subtotal_amount)) {
                subtotal_input.value = '0.00';
                vat_input.value = '0.00';
                total_input.value = '0.00';

            } else {
                subtotal_amount = parseFloat(subtotal_amount.toFixed(2));
                subtotal_input.value = subtotal_amount.toFixed(2);

                vat_amount = parseFloat((subtotal_amount * 0.15).toFixed(2));
                vat_input.value = vat_amount.toFixed(2);

                total_amount = parseFloat((subtotal_amount + vat_amount).toFixed(2));
                total_input.value = total_amount.toFixed(2)
            }

            recalculate_totals()
        }

        function calculate_sums(selector) {
            let sum = 0, value;

            estimation_fields.querySelectorAll(selector).forEach(function (e) {
                value = parseFloat(e.value.replace(' ', ''))
                sum += isNaN(value) ? 0 : value;
            });

            return sum;
        }

        function recalculate_totals() {
            const estimation_subtotal = document.querySelector('#cms_repair_quotation_subtotal')
            const estimation_vat = document.querySelector('#cms_repair_quotation_vat')
            const estimation_total = document.querySelector('#cms_repair_quotation_total')

            estimation_subtotal.value = calculate_sums('.subtotal').toFixed(2);
            estimation_vat.value = calculate_sums('.vat').toFixed(2);
            estimation_total.value = calculate_sums('.total').toFixed(2);
        }

        document.querySelectorAll('input.trigger_calculation').forEach(function (e) {
            e.addEventListener("change", function () {
                recalculate_estimation(e);
            });
        });
    }
});
